import { render } from "./SpaDayConfirmation.vue?vue&type=template&id=1e60d765"
import script from "./SpaDayConfirmation.vue?vue&type=script&lang=js"
export * from "./SpaDayConfirmation.vue?vue&type=script&lang=js"

import "./SpaDayConfirmation.vue?vue&type=style&index=0&id=1e60d765&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__